var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"text-body-2 font-weight-bold"},[_vm._v(" Tips: Hidden columns can be shown by using the button at right-top corner of the table. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }